import { ContentHeader, PageHeaderLayout, RouteTabWithContent, TabContent } from "@homebound/beam";
import { useMemo } from "react";
import { Navigate } from "react-router-dom";
import { Loading } from "src/components/Loading";
import { useFeatureFlag } from "src/contexts/FeatureFlags/FeatureFlagContext";
import { useUserFeatureFlagsQuery } from "src/contexts/FeatureFlags/FeatureFlagContext.generated";
import { FeatureFlagType } from "src/generated/graphqlTypes";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProductOfferingsOverviewTab } from "src/routes/libraries/product-offerings/overview/ProductOfferingsOverviewTab";
import { ProjectParams } from "src/routes/routesDef";
import * as projectPaths from "src/routing/domains/projectsPaths";

export function ProductOfferingsPageV2() {
  const isProductOfferingsV2Enabled = useFeatureFlag(FeatureFlagType.ProductOfferingsV2);
  const { loading: flagsLoading } = useUserFeatureFlagsQuery();
  const { projectId } = useRouteParams<ProjectParams>();
  const tabs: RouteTabWithContent[] = useMemo(
    () => [
      {
        name: "Overview",
        href: projectPaths.projectProductOfferingsOverviewRoute.url({ projectId }),
        path: projectPaths.projectProductOfferingsOverviewRoute.path,
        render: () => <ProductOfferingsOverviewTab projectId={projectId} />,
      },
      {
        name: "Options",
        href: projectPaths.projectProductOfferingsOptionsRoute.url({ projectId }),
        path: projectPaths.projectProductOfferingsOptionsRoute.path,
        render: () => <OptionsTab />,
      },
    ],
    [projectId],
  );

  if (flagsLoading) return <Loading />;
  if (!isProductOfferingsV2Enabled) {
    return <Navigate to={projectPaths.projectProductOfferingsRoute.url({ projectId })} replace />;
  }

  return (
    <PageHeaderLayout pageHeader={{ title: "Product Offerings", tabs: { tabs } }}>
      <TabContent tabs={tabs} />
    </PageHeaderLayout>
  );
}

function OptionsTab() {
  return (
    <ContentHeader
      title="Options"
      description="Manage which options are available in Checkout and Underwriting across all plans in this community. All conflicts and dependencies are already attached."
    />
  );
}
